/**
 * Semantic visual tokens — Phaser + React shell.
 * M79–M80 production language: hybrid geometric premium.
 * Shape identifies; color reinforces (never sole cue).
 */

export const THEME = {
  // Shell / atmosphere
  background: 0x0b1220,
  surface: 0x152033,
  surfaceElevated: 0x1c2a40,
  text: 0xf1f5f9,
  textMuted: 0x94a3b8,
  success: 0x34d399,
  warning: 0xfbbf24,
  danger: 0xf87171,

  // Board
  board: 0x1a2740,
  boardEdge: 0x2a3b55,
  grass: 0x3d6b2e,
  grassAlt: 0x345a27,
  path: 0x7a5a3a,
  pathEdge: 0x5c4228,
  pathInner: 0x9a7350,
  grid: 0x1e3a28,
  selection: 0xfbbf24,
  valid: 0x34d399,
  invalid: 0xf87171,
  locked: 0x64748b,

  // Towers (family identity)
  fire: 0xe85d4c,
  frost: 0x4b8fd9,
  cannon: 0x2a3344,
  poison: 0x9ccc3c,
  aa: 0x2ec4d9,
  mage: 0xb57ae8,

  // Enemies
  normalEnemy: 0xe85d4c,
  fastEnemy: 0xf0b429,
  tankEnemy: 0x7c5cbf,
  regenEnemy: 0x2bb3a0,
  shieldEnemy: 0x6b7c8f,
  bossEnemy: 0x8b2a2a,
  flyerEnemy: 0x4db8e8,
  airBossEnemy: 0x1a6fa8,
  guardianEnemy: 0x8fa0b3,
  phaseEnemy: 0xa78bfa,
  crystalEnemy: 0x5ed4e0,

  // Feedback / status
  statusReject: 0xcbd5e1,
  hp: 0x34d399,
  hpBack: 0x0b1220,
  shield: 0xe2e8f0,
  shieldBack: 0x2a3b55,
  /** Combat reward floater (Coins — not “Gold” UI copy). */
  gold: 0x4ade80,
  frostMark: 0x5bb8e8,
  poisonMark: 0x8bc34a,
  burnMark: 0xf07838,
  armorBreakMark: 0xd88cf0,
  deepFreeze: 0xdceef8,
  white: 0xf8fafc,
  labelDark: 0x1a3320,
  spawn: 0xf8fafc,
  exit: 0xf5d78a,
  airRoute: 0x5bb8e8,
  projectileFire: 0xf07838,
  projectileFrost: 0x5bb8e8,
  projectileCannon: 0x4a5568,
  projectilePoison: 0x8bc34a,
  projectileAa: 0x67e0f0,
  projectileMage: 0xe0c4ff
} as const

export type ThemeToken = keyof typeof THEME

/** CSS-friendly #rrggbb for React shell alignment. */
export function themeCss(token: ThemeToken): string {
  const value = THEME[token]
  return `#${value.toString(16).padStart(6, '0')}`
}
